import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { salesCrmApi } from "./api";
import "./salescrm.css";

const SalesManualLead = () => {
  const navigate = useNavigate();
  const [hccId, setHccId] = useState("");
  const [notes, setNotes] = useState("");
  const [priority, setPriority] = useState("normal");
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const res = await salesCrmApi.createManual({
        hcc_id: hccId.trim(),
        notes,
        priority,
      });
      navigate(`/dashboard/sales-crm/leads/${res.data.id}`);
    } catch (err) {
      setError(err?.response?.data?.detail || "Could not create lead.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="child-sidenav">
      <div className="childnav-content scrm-page">
        <div className="scrm-header">
          <div>
            <h2>Add manual / referral lead</h2>
            <p>
              Links to an existing ICC profile by member ID. Does not create a
              duplicate customer.
            </p>
          </div>
          <button
            type="button"
            className="scrm-btn scrm-btn-outline"
            onClick={() => navigate("/dashboard/sales-crm")}
          >
            Cancel
          </button>
        </div>

        {error && <div className="scrm-alert err">{error}</div>}

        <div className="scrm-card" style={{ maxWidth: 520 }}>
          <form className="scrm-form" onSubmit={submit}>
            <label>
              ICC / HCC member ID
              <input
                value={hccId}
                onChange={(e) => setHccId(e.target.value)}
                placeholder="e.g. ICC1234 or HCC1234"
                required
              />
            </label>
            <label>
              Priority
              <select
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
              >
                <option value="normal">Normal</option>
                <option value="hot">Hot</option>
              </select>
            </label>
            <label>
              Notes
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Referral from production house / event…"
              />
            </label>
            <button
              type="submit"
              className="scrm-btn scrm-btn-primary"
              disabled={saving}
            >
              {saving ? "Creating…" : "Create opportunity"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export { SalesManualLead };
